import React from 'react'
import styled from 'styled-components'

const Container = styled('div')`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;

	@keyframes pulse {
		0% {
			transform: scale(1);
		}
		50% {
			transform: scale(1.4) rotate(12deg);
		}
		100% {
			transform: scale(1);
		}
	}

	img {
		max-width: 40px;
		max-height: 40px;
		animation: pulse 3s ease infinite;
		margin-bottom: 7px;
	}
`

const Loader = ({ message }) => {
	return (
		<Container>
			<img alt="NeverWait" src={`${process.env.PUBLIC_URL}/scissor-and-comb.svg`} />
			{message}
		</Container>
	)
}

export default Loader
